import rp004 from "./rp004";
import rp012 from "./rp012";
import rp013 from "./rp013";
import rp026 from "./rp026";
import rp014d from "./rp014d";
import rp027 from "./rp027";
import denominationpending from "./denominationpending";
import rp024 from "./rp024";

export default {
    rp004,
    rp012,
    rp013,
    rp026,
    rp014d,
    rp027,
    denominationpending,
    rp024
}